<div class="d-flex table-select-container">
  <div>
    <button
      [ngClass]="
        selectedOverview === 'new'
          ? 'selected-button border-badge-selected'
          : 'non-selected-button border-badge'
      "
      (click)="changeSelectedView('new')"
      type="button"
      mat-button
    >
      <span
        class="span-badge-margin"
        [ngClass]="
          selectedOverview === 'new' ? 'border-badge-selected' : 'border-badge'
        "
        matBadge="{{ countNew }}"
        [matBadgeHidden]="countNew == null || countNew === 0"
        [matBadgeSize]="'medium'"
        matBadgeOverlap="false"
      ></span>
      Nieuwe
    </button>
  </div>
  <div>
    <button
      [ngClass]="
        selectedOverview === 'noTour'
          ? 'selected-button border-badge-selected'
          : 'non-selected-button border-badge'
      "
      (click)="changeSelectedView('noTour')"
      type="button"
      mat-button
    >
      <span
        class="span-badge-margin"
        [ngClass]="
          selectedOverview === 'noTour'
            ? 'border-badge-selected'
            : 'border-badge'
        "
        matBadge="{{ countNoTour }}"
        [matBadgeHidden]="countNoTour == null || countNoTour === 0"
        [matBadgeSize]="'medium'"
        matBadgeOverlap="false"
      ></span>
      Niet in toer
    </button>
  </div>
  <div>
    <button
      [ngClass]="
        selectedOverview === 'delayed'
          ? 'selected-button border-badge-selected'
          : 'non-selected-button border-badge'
      "
      (click)="changeSelectedView('delayed')"
      type="button"
      mat-button
    >
      <span
        class="span-badge-margin"
        [ngClass]="
          selectedOverview === 'delayed'
            ? 'border-badge-selected'
            : 'border-badge'
        "
        matBadge="{{ countDelayed }}"
        [matBadgeHidden]="countDelayed == null || countDelayed === 0"
        [matBadgeSize]="'medium'"
        matBadgeOverlap="false"
      ></span>
      Uitgesteld
    </button>
  </div>
</div>

<appointment-new-immo-overview
  *ngIf="selectedOverview === 'new'"
  (countChange)="updateNewCount($event)"
>
</appointment-new-immo-overview>
<appointment-no-tour-immo-overview
  *ngIf="selectedOverview === 'noTour'"
  (countChange)="updateNoTourCount($event)"
>
</appointment-no-tour-immo-overview>
<delayed-immo-overview
  *ngIf="selectedOverview === 'delayed'"
  (countChange)="updateDelayedCount($event)"
>
</delayed-immo-overview>
